import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { GridRow } from "../../layout/GridRow";
import { Paragraph } from "../../typography/Paragraph";
import { getQuoteSource } from "./utils/getQuoteSource";
export var Component = function Component(_ref) {
  var quoteDateTime = _ref.quoteDateTime,
      quoteSource = _ref.quoteSource,
      quoteText = _ref.quoteText;
  return React.createElement("blockquote", {
    className: "ui quote"
  }, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Paragraph, null, quoteText))), React.createElement(GridRow, {
    horizontalAlignContent: "right"
  }, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Paragraph, {
    size: "tiny"
  }, getQuoteSource(quoteSource, quoteDateTime))))));
};
Component.displayName = 'Quote';
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  quoteDateTime: PropTypes.string.isRequired,
  quoteSource: PropTypes.string.isRequired,
  quoteText: PropTypes.string.isRequired
} : {};